import React from "react";
import { useEntries } from "@/context/EntriesContext";
import MicButton from "@/components/MicButton";

// Autosaving journaling field bound to an entry key, with optional dictation.
export default function Field({ entryKey, label, placeholder, rows = 4, prompts, testid, readOnly = false }) {
  const { getEntry, saveEntry, savingKeys } = useEntries();
  const value = getEntry(entryKey, "");
  const saving = savingKeys[entryKey];
  let savingLabel = "";
  if (saving) savingLabel = "Saving\u2026";
  else if (value) savingLabel = "Saved";

  return (
    <div className="mb-7">
      {label && (
        <div className="mb-2 flex items-baseline justify-between gap-3">
          <label className="font-serif text-xl text-stone-900">{label}</label>
          {!readOnly && (
            <span className="text-xs text-stone-400 transition-opacity duration-300">
              {savingLabel}
            </span>
          )}
        </div>
      )}
      {prompts && prompts.length > 0 && (
        <ul className="mb-2 space-y-0.5">
          {prompts.map((p) => (
            <li key={p} className="text-sm italic text-stone-500">– {p}</li>
          ))}
        </ul>
      )}
      <div className="relative">
        <textarea
          data-testid={testid}
          readOnly={readOnly}
          value={typeof value === "string" ? value : ""}
          onChange={(e) => saveEntry(entryKey, e.target.value)}
          placeholder={placeholder || "Write or speak freely\u2026"}
          rows={rows}
          className="w-full resize-y bg-transparent border-b border-stone-300 rounded-none px-0 py-2 pr-2 text-base leading-relaxed text-stone-800 placeholder:text-stone-400 focus:outline-none focus:border-brand-primary transition-colors duration-300"
        />
        {!readOnly && (
          <div className="mt-1.5 flex justify-end">
            <MicButton
              testid={testid ? `${testid}-mic` : undefined}
              getValue={() => getEntry(entryKey, "")}
              onChange={(v) => saveEntry(entryKey, v)}
            />
          </div>
        )}
      </div>
    </div>
  );
}
